(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collections-mf"] && !Shopify.designMode) return;
  try {
    (function () {
  
  const container = document.querySelector('#AjaxinateContainer');
  if (!container) return;

  // Hard-disable when filters are active:
  // - preferred: container dataset (add via Liquid in collection-grid.liquid)
  // - fallback: URL contains filter.* params
  function filtersActiveFromUrl() {
    const sp = new URLSearchParams(window.location.search);
    for (const k of sp.keys()) {
      if (k.startsWith('filter.')) return true;
    }
    return false;
  }

  const ds = container.dataset || {};
  const filtersActive = (ds.filtersActive === 'true') || filtersActiveFromUrl();
  const enabledByLiquid = (ds.mfCollectionsEnabled === 'true') || true; // snippet only renders when enabled; dataset is best-effort

  if (!enabledByLiquid || filtersActive) return;

  // Prevent duplicate boot (section AJAX reloads can evaluate scripts again)
  if (container.dataset.mfHybridBooted === '1') return;
  container.dataset.mfHybridBooted = '1';

  const CFG = window.__MF_COLLECTIONS__ || {};
  const handles = Array.isArray(CFG.handles) ? CFG.handles.slice() : [];
  const serverLimit = Number(CFG.serverLimit || 10);
  const productsLimit = Number(CFG.productsLimit || 8);
  const sortBy = CFG.sortBy || '';

  // Track how many we’ve appended total (server already rendered first N)
  const renderedCount = Number(CFG.renderedCount || serverLimit);
  let cursor = renderedCount;

  const pageSize = 12;
  const cache = new Map();        // handle -> card JSON
  let prefetching = false;
  // One IntersectionObserver; append-only
  const sentinel = container.querySelector('[data-mf-sentinel="1"]');
  if (!sentinel) return;

  const loadMoreBtn = container.querySelector('[data-mf-loadmore="1"]');
  const loadMoreLabel = loadMoreBtn ? loadMoreBtn.textContent : '';

  // Swiper init (idempotent)
  function waitForSwiper(maxMs = 4000) {
    const start = Date.now();
    return new Promise((resolve) => {
      (function tick() {
        if (typeof window.Swiper === 'function') return resolve(true);
        if (Date.now() - start > maxMs) return resolve(false);
        requestAnimationFrame(tick);
      })();
    });
  }

  const swiperInstances = new Set();
 
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }
  function setHeroImage(cardEl, newSrc) {
    if (!cardEl || !newSrc) return;

    const heroImg = cardEl.querySelector('.parent-subcategory-image img');
    if (!heroImg) return;

    // Remove srcset/sizes so src swap reliably wins (server hero can have responsive attrs)
    if (heroImg.dataset.origSrcset == null) heroImg.dataset.origSrcset = heroImg.getAttribute('srcset') || '';
    if (heroImg.dataset.origSizes == null) heroImg.dataset.origSizes = heroImg.getAttribute('sizes') || '';

    heroImg.removeAttribute('srcset');
    heroImg.removeAttribute('sizes');

    heroImg.src = newSrc;

    // Treat this as the "selected" hero (mouseout should restore to this)
    heroImg.dataset.origSrc = newSrc;
  }

  function initSwipersWithin(root) {
    if (typeof window.Swiper !== 'function') return;

    root.querySelectorAll('.product-swiper').forEach((swiperEl) => {
      if (swiperEl.swiper) return;
      if (swiperEl.dataset.swiperInit === '1') return;

      const nextBtn = swiperEl.querySelector('.product-next');
      const prevBtn = swiperEl.querySelector('.product-prev');
      const slides = swiperEl.querySelectorAll('.swiper-slide');
      const totalSlides = slides.length;

      if (totalSlides <= 3) {
        swiperEl.dataset.swiperInit = '1';

        const wrapper = swiperEl.querySelector('.swiper-wrapper');
        if (wrapper) {
          wrapper.style.display = 'flex';
          wrapper.style.justifyContent = 'center';
          wrapper.style.gap = '10px';
          wrapper.style.transform = 'none';
        }

        slides.forEach((slide) => {
          slide.style.width = '100px';
          slide.style.flex = '0 0 100px';
        });

        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';

        const card = swiperEl.closest('.parent-subcategory__item');
        if (card && slides[0]) {
          const img = slides[0].querySelector('.subcategory-product__thumb img');
          const full = img && (img.getAttribute('data-full') || img.getAttribute('src'));
          if (full) setHeroImage(card, full);
        }

        return;
      }
      if (!nextBtn || !prevBtn) return;

      swiperEl.dataset.swiperInit = '1';

      const inst = new window.Swiper(swiperEl, {
        slidesPerView: 3,
        spaceBetween: 10,
        watchOverflow: true,
        centerInsufficientSlides: true,
        observer: true,
        observeParents: true
        // NOTE: do NOT use Swiper navigation here; we handle arrows ourselves
      });

      // Store focusIndex on the swiper instance so delegated clicks can update it.
      inst.__mfFocusIndex = clamp(inst.__mfFocusIndex ?? 0, 0, inst.slides.length - 1);

      const card = swiperEl.closest('.parent-subcategory__item');

      function setHeroFromIndex(idx) {
        if (!card) return;
        const slide = inst.slides && inst.slides[idx];
        if (!slide) return;

        const img = slide.querySelector('.subcategory-product__thumb img');
        if (!img) return;

        const full = img.getAttribute('data-full') || img.getAttribute('src');
        if (!full) return;

        setHeroImage(card, full);
      }

      function updateNav() {
        const total = inst.slides ? inst.slides.length : 0;
        const last = total - 1;

        // If there are 0/1 slides, or not enough to scroll, hide both.
        // (Use slidesPerView from params; handles responsive changes better.)
        const spv = Number(inst.params && inst.params.slidesPerView) || 1;
        const canScroll = total > spv;

        if (!canScroll || last < 1) {
          prevBtn.style.display = 'none';
          nextBtn.style.display = 'none';
          return;
        }

        prevBtn.style.display = inst.__mfFocusIndex <= 0 ? 'none' : '';
        nextBtn.style.display = inst.__mfFocusIndex >= last ? 'none' : '';
      }

      // Initialize hero + nav to focused thumb 0
      setHeroFromIndex(inst.__mfFocusIndex);
      updateNav();

      // Ensure focused thumb is visible
      inst.slideTo(inst.__mfFocusIndex, 0);

      // Buttons move focus by 1 (THIS is the key)
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        inst.__mfFocusIndex = clamp(inst.__mfFocusIndex + 1, 0, inst.slides.length - 1);
        inst.slideTo(inst.__mfFocusIndex);
        setHeroFromIndex(inst.__mfFocusIndex);
        updateNav();
      });

      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        inst.__mfFocusIndex = clamp(inst.__mfFocusIndex - 1, 0, inst.slides.length - 1);
        inst.slideTo(inst.__mfFocusIndex);
        setHeroFromIndex(inst.__mfFocusIndex);
        updateNav();
        // Ensure nav reflects final state after Swiper settles
        requestAnimationFrame(updateNav);
        setTimeout(updateNav, 0);
      });

      function refreshFromSwiperPosition() {
        // If user swiped, align focusIndex to whatever Swiper considers active
        inst.__mfFocusIndex = clamp(inst.__mfFocusIndex ?? inst.activeIndex ?? 0, 0, inst.slides.length - 1);
        setHeroFromIndex(inst.__mfFocusIndex);
        updateNav();
      }

      inst.on('slideChange', refreshFromSwiperPosition);
      inst.on('transitionEnd', refreshFromSwiperPosition);
      inst.on('update', refreshFromSwiperPosition);
      inst.on('resize', refreshFromSwiperPosition);

      // After layout settles, update once more
      requestAnimationFrame(() => {
        inst.update();
        inst.__mfFocusIndex = clamp(inst.__mfFocusIndex, 0, inst.slides.length - 1);
        setHeroFromIndex(inst.__mfFocusIndex);
        updateNav();
      });

      setTimeout(() => {
        inst.update();
        inst.__mfFocusIndex = clamp(inst.__mfFocusIndex, 0, inst.slides.length - 1);
        setHeroFromIndex(inst.__mfFocusIndex);
        updateNav();
      }, 200);

      swiperInstances.add(inst);
    });
  }

  // Delegated hover (no per-card listeners; no leaks)
  if (container.dataset.mfHoverBound !== '1') {
    container.dataset.mfHoverBound = '1';

    container.addEventListener('mouseover', (e) => {
      const thumbImg = e.target && e.target.closest && e.target.closest('.subcategory-product__thumb img');
      if (!thumbImg) return;

      const card = thumbImg.closest('.parent-subcategory__item');
      if (!card) return;

      const heroImg = card.querySelector('.parent-subcategory-image img');
      if (!heroImg) return;

      if (!heroImg.dataset.origSrc) heroImg.dataset.origSrc = heroImg.src;
      const full = thumbImg.dataset.full;
      if (full) heroImg.src = full;
    });

    container.addEventListener('mouseout', (e) => {
      const thumbImg = e.target && e.target.closest && e.target.closest('.subcategory-product__thumb img');
      if (!thumbImg) return;

      const card = thumbImg.closest('.parent-subcategory__item');
      if (!card) return;

      const heroImg = card.querySelector('.parent-subcategory-image img');
      if (!heroImg) return;

      const orig = heroImg.dataset.origSrc;
      if (orig) heroImg.src = orig;
    });
    // Click-to-select: clicking a thumb sets focusIndex + moves swiper + updates hero
    container.addEventListener('click', (e) => {
      const thumbImg = e.target && e.target.closest && e.target.closest('.subcategory-product__thumb img');
      if (!thumbImg) return;

      const swiperEl = thumbImg.closest('.product-swiper');
      if (!swiperEl || !swiperEl.swiper) return;

      const slideEl = thumbImg.closest('.swiper-slide');
      if (!slideEl) return;

      const inst = swiperEl.swiper;
      const slides = swiperEl.querySelectorAll('.swiper-slide');
      const idx = Array.prototype.indexOf.call(slides, slideEl);
      if (idx < 0) return;

      inst.__mfFocusIndex = clamp(idx, 0, inst.slides.length - 1);
      inst.slideTo(inst.__mfFocusIndex);
      
      const card = thumbImg.closest('.parent-subcategory__item');
      const full = thumbImg.getAttribute('data-full') || thumbImg.getAttribute('src');
      if (card && full) setHeroImage(card, full);
    });
  }

  // Build card DOM from JSON (no Accept header; parse text)
  function buildCard(data) {
    const hero = data.hero;
    const products = Array.isArray(data.products) ? data.products : [];

    // Hero loading rules for appended cards: lazy + low priority (preserve LCP stability)
const heroImgHtml = hero ? `
  <img
    src="${hero.src}"
    ${hero.srcset ? `srcset="${hero.srcset.replace(/"/g, '&quot;')}"` : ''}
    ${hero.sizes ? `sizes="${hero.sizes.replace(/"/g, '&quot;')}"` : ''}
    alt="${(hero.alt || data.title || '').replace(/"/g, '&quot;')}"
    height="300"
    width="330"
    loading="lazy"
    decoding="async"
    fetchpriority="low"
  >
` : '';

    const productLis = products.slice(0, productsLimit).map((p) => {
      if (!p || !p.image) return `<li class="swiper-slide product"></li>`;
      const alt = (p.image.alt || p.title || '').replace(/"/g, '&quot;');
      // Use thumb sizing similar to server-rendered
      return `
        <li class="swiper-slide product">
          <div class="subcategory-product__thumb">
            <img
              src="${p.image.src}"
              alt="${alt}"
              height="100"
              width="100"
              loading="lazy"
              class="product-list__image"
              data-full="${p.image.src}"
            >
          </div>
        </li>
      `;
    }).join('');

    const designer = data.designer_collection ? `
      <div class="rug-designer-collection">${data.designer_collection}</div>
    ` : '';

    const wrap = document.createElement('div');
    wrap.className = `grid-item grid-product`;
    wrap.setAttribute('data-collection-handle', data.handle);
    wrap.setAttribute('data-collection-id', data.id);

    wrap.innerHTML = `
      <div class="grid-item__content">
        <div class="parent-subcategory__item">
          <div class="parent-subcategory-item__body">
            <a href="${data.url}">
              <div class="parent-subcategory-image">
                ${heroImgHtml}
              </div>
            </a>

            <div class="collection-products-grid">
              <div class="swiper product-swiper">
                <ul class="swiper-wrapper products">
                  ${productLis}
                </ul>
                <div class="swiper-button-next product-next"></div>
                <div class="swiper-button-prev product-prev"></div>
              </div>
            </div>
          </div>

          <div class="parent-subcategory-item__footer">
            <a href="${data.url}" class="parent-subcategory__title">${data.title}</a>
            ${designer}
          </div>
        </div>
      </div>
    `;
    return wrap;
  }

  async function fetchCard(handle) {
    const url =
      `/collections/${encodeURIComponent(handle)}?view=collection-card` +
      `&limit=${encodeURIComponent(productsLimit)}` +
      (sortBy ? `&sort_by=${encodeURIComponent(sortBy)}` : '');

    // IMPORTANT: no Accept: application/json header
    const res = await fetch(url, { method: 'GET', credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Hydrate failed ${res.status} for ${handle}`);

    const txt = await res.text();
    // Some themes/proxies might inject whitespace; JSON.parse handles it.
    return JSON.parse(txt);
  }

  async function prefetchNextPage() {
    if (prefetching) return;
    if (cursor >= handles.length) return;

    prefetching = true;
    try {
      const start = cursor;
      const end = Math.min(cursor + pageSize, handles.length);

      // Fetch in small parallel batches (don’t spike)
      const concurrency = 3;
      let i = start;

      while (i < end) {
        const slice = handles.slice(i, Math.min(i + concurrency, end)).filter(Boolean);

        await Promise.all(slice.map(async (h) => {
          if (cache.has(h)) return;
          try {
            const data = await fetchCard(h);
            cache.set(h, data);
          } catch (e) {
            // ignore single failures; don't block entire prefetch
          }
        }));

        i += concurrency;
      }
    } finally {
      prefetching = false;
    }
  }
  
  function setButtonLoading(isLoading) {
    if (!loadMoreBtn) return;

    if (isLoading) {
      loadMoreBtn.disabled = false;
      loadMoreBtn.textContent = 'Loading…';
      loadMoreBtn.setAttribute('aria-busy', 'true');
    } else {
      loadMoreBtn.disabled = false;
      loadMoreBtn.textContent = loadMoreLabel || 'Click To Load More';
      loadMoreBtn.removeAttribute('aria-busy');
    }
  }

  let pumping = false;
  
  async function pump(batchSize = 12) {
    if (pumping) return;
    pumping = true;

    setButtonLoading(true);

    try {
      // Stop if filters got activated mid-session
      if (filtersActiveFromUrl() || container.dataset.filtersActive === 'true') return;

      const end = Math.min(cursor + batchSize, handles.length);
      if (cursor >= end) return;

      // 1) Fetch data first (NO DOM changes yet)
      const batch = [];
      for (let i = cursor; i < end; i++) {
        const handle = handles[i];
        if (!handle) continue;

        const data = await fetchCard(handle); // sequential, stable
        batch.push(data);
      }

      // 2) Build nodes in memory (still no DOM changes)
      const nodes = batch.map(buildCard);

      // 3) Append in one go (minimize reflow)
      const frag = document.createDocumentFragment();
      nodes.forEach((n) => frag.appendChild(n));
      container.insertBefore(frag, sentinel);

      // 4) Move cursor forward by the full window we attempted
      cursor = end;

      // 5) Init swipers for the newly appended nodes
      const ok = await waitForSwiper();
      if (ok) {
        nodes.forEach((n) => initSwipersWithin(n));
      }

      // Hide button if done
      if (loadMoreBtn && cursor >= handles.length) {
        loadMoreBtn.disabled = true;
        loadMoreBtn.style.display = 'none';
      }

    } catch (e) {
      // Optional: show failure state
      // console.warn('[collections-mf] pump error', e);
    } finally {
      setButtonLoading(false);
      pumping = false;
    }
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => pump(12));
  }
  // Init swipers for server-rendered cards (after Swiper available)
  waitForSwiper().then((ok) => {
    if (!ok) return;
    initSwipersWithin(container);
  });

// const io = new IntersectionObserver((entries) => {
//   const hit = entries && entries[0] && entries[0].isIntersecting;
//   if (!hit) return;

//   // Prefetch only. Do NOT append.
//   prefetchNextPage();
// }, { root: null, rootMargin: '1200px 0px', threshold: 0.01 });

// io.observe(sentinel);

  // Coexist with Ajaxinate: if Ajaxinate appends nodes, just init swipers in container
  document.addEventListener('ajaxinate:loaded', () => {
    waitForSwiper().then((ok) => {
      if (!ok) return;
      initSwipersWithin(container);
    });
  });

})();
  } catch(e) { console.error(e); }
})();

})();
